import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { AppGuardService } from '../core/guards/app-guard.service';
import { Page403Component } from './error/page403/page403.component';
import { Page401Component } from './error/page401/page401.component';
import { Page408Component } from './error/page408/page408.component';

export const routes: Routes = [
  {
    path: 'sso-receptor',
     
    loadComponent: () =>
      import('./auth/sso-receiver/sso-receiver.component').then(
        (m) => m.SsoReceiverComponent,
      )
  },
  {
    path: '', component: LayoutComponent, children: [
      {
        path: '', redirectTo: 'home/inicio', pathMatch: 'full'
      },
      {
        path: "home", loadChildren: () => import('./home/home.module').then(m => m.HomeModule), canActivate: [AppGuardService]
      },
      {
        path: "contacto/contacto", loadChildren: () => import('./contacto/contacto.module').then(m => m.ContactoModule), canActivate: [AppGuardService]
      },
      {
        path: "configuracion/producto", loadChildren: () => import('./configuracion/producto/producto.module').then(m => m.ProductoModule), canActivate: [AppGuardService]
      },
      {
        path: "configuracion/estructura", loadChildren: () => import('./configuracion/estructura/estructura.module').then(m => m.EstructuraModule), canActivate: [AppGuardService]
      },
      {
        path: "configuracion/reglas", loadChildren: () => import('./configuracion/reglas/reglas.module').then(m => m.ReglasModule), canActivate: [AppGuardService]
      },
      {
        path: "cobertura/busqueda", loadChildren: () => import('./cobertura/busqueda/busqueda.module').then(m => m.BusquedaModule), canActivate: [AppGuardService]
      },
      {
        path: "cobertura/registrosolicitud", loadChildren: () => import('./cobertura/registroSolicitud/registroSolicitud.module').then(m => m.RegistroSolicitudModule), canActivate: [AppGuardService]
      },
      {
        path: "cobertura/extorno", loadChildren: () => import('./cobertura/extorno/extorno.module').then(m => m.ExtornoModule), canActivate: [AppGuardService]
      },
      {
        path: "cobertura/gestionsubasta", loadChildren: () => import('./cobertura/gestionSubasta/gestionSubasta.module').then(m => m.GestionSubastaModule), canActivate: [AppGuardService]
      },
      {
        path: "credito/gestioncredito", loadChildren: () => import('./credito/gestionCredito/gestionCredito.module').then(m => m.GestionCreditoModule), canActivate: [AppGuardService]
      },
      {
        path: "mantenimientos", loadChildren: () => import('./mantenimientos/mantenimientos.module').then(m => m.MantenimientosModule), canActivate: [AppGuardService]
      },
      {
        path: "honramiento/busqueda", loadChildren: () => import('./honramiento/busqueda/busqueda.module').then(m => m.BusquedaModule), canActivate: [AppGuardService]
      },
      {
        path: "honramiento/busqueda/:esSimulacion", loadChildren: () => import('./honramiento/busqueda/busqueda.module').then(m => m.BusquedaModule)
      },
      {
        path: "honramiento/registro", loadChildren: () => import('./honramiento/registroHonras/registrohonras/registroHonras.module').then(m => m.RegistroHonrasModule), canActivate: [AppGuardService]
      },
      {
        path: "honramiento/simulador", loadChildren: () => import('./honramiento/simuladorhonras/simuladorhonras.module').then(m => m.SimuladorhonrasModule), canActivate: [AppGuardService]
      },
      {
        path: "honramiento/reintento", loadChildren: () => import('./honramiento/reintento/reintento-sap.module').then(m => m.ReintentoSapModule), canActivate: [AppGuardService]
      },
      {
        path: "honramiento/reporte", loadChildren: () => import('./honramiento/reporte-honrados/reporte-honrados.module').then(m => m.ReporteHonradosModule), canActivate: [AppGuardService]
      },
      {
        path: "bpagador/registrosolicitud", loadChildren: () => import('./buenpagador/registroSolicitudBuenpagador/registroSolicitud-buenpagador.module').then(m => m.RegistroSolicitudBuenPagadorModule), canActivate: [AppGuardService]
      },
      {
        path: "bpagador/busqueda", loadChildren: () => import('./buenpagador/busqueda/busqueda-bpagador.module').then(m => m.BusquedaBuenPagadorModule), canActivate: [AppGuardService]
      },
      {
        path: "bpagador/reintento", loadChildren: () => import('./buenpagador/reintentobbp/reintento-bbp.module').then(m => m.ReintentoBbpModule), canActivate: [AppGuardService]
      },
      {
        path: "bpagador/registroaplicacion", loadChildren: () => import('./buenpagador/registroAplicacionDesembolsos/registro-aplicacion-desembolsos.module').then(m => m.RegistroAplicacionDesembolsosModule), canActivate: [AppGuardService]
      },
      {
        path: "bpagador/busqueda-aplicacion", loadChildren: () => import('./buenpagador/busqueda-aplicacion/busqueda-aplicacion.module').then(m => m.BusquedaAplicacionModule), canActivate: [AppGuardService]
      },
      {
        path: "bpagador/reporte", loadChildren: () => import('./buenpagador/reporte-bbp/reporte-bbp.module').then(m => m.ReporteBbpModule), canActivate: [AppGuardService]
      },
      {
        path: "flujorecuperado/busqueda", loadChildren: () => import('./Recuperacion/flujo-recuperado/busqueda-flujo/busqueda-flujo.module').then(m => m.BusquedaFlujoModule), canActivate: [AppGuardService]
      },
      {
        path: "flujorecuperado/registro", loadChildren: () => import('./Recuperacion/flujo-recuperado/Carga-Flujo/Carga-Flujo-Recuperado.module').then(m => m.CargaFlujoRecuperadoModule), canActivate: [AppGuardService]
      },
      {
        path: "castigo/busqueda", loadChildren: () => import('./Recuperacion/Castigo/busqueda-Castigo.module').then(m => m.BusquedaCastigoModule), canActivate: [AppGuardService]
      },
      {
        path: "castigo/registro", loadChildren: () => import('./Recuperacion/flujo-recuperado/Carga-Flujo/Carga-Flujo-Recuperado.module').then(m => m.CargaFlujoRecuperadoModule), canActivate: [AppGuardService]
      },
      {
        path: "reportemensual/busqueda", loadChildren: () => import('./SeguimientoCartera/reporte-mensual/Busqueda/Busqueda.module').then(m => m.BusquedaReporteMensualModule), canActivate: [AppGuardService]
      },
      {
        path: "reportemensual/registro", loadChildren: () => import('./SeguimientoCartera/reporte-mensual/Carga-reporte-mensual/carga-reporte-mensual.module').then(m => m.CargaReporteMensualModule), canActivate: [AppGuardService]
      },
      {
        path: "comision/busqueda", loadChildren: () => import('./Comisiones/busqueda/busqueda.module').then(m => m.BusquedaModule), canActivate: [AppGuardService]
      },
      {
        path: "cobranzajudicial/busqueda", loadChildren: () => import('./cobranzajudicial/busqueda/busqueda.module').then(m => m.BusquedaModule), canActivate: [AppGuardService]
      },
      {
        path: "cobranzajudicial/registro", loadChildren: () => import('./cobranzajudicial/carga-cobranza/carga-cobranza.module').then(m => m.CargaCobranzaModule), canActivate: [AppGuardService]
      },
      {
        path: "cobranzajudicial/resumen", loadChildren: () => import('./cobranzajudicial/resumen-judicial/resumen-judicial.module').then(m => m.ResumenJudicialModule), canActivate: [AppGuardService]
      },
      {
        path: "cobranzajudicial/informe", loadChildren: () => import('./cobranzajudicial/carga-informe/carga-informe-judicial.module').then(m => m.CargaInformeJudicialModule)
      },
      {
        path: "reportesemanal/busqueda", loadChildren: () => import('./SeguimientoCartera/reporte-semanal/Busqueda/Busqueda.module').then(m => m.BusquedaReporteSemanalModule), canActivate: [AppGuardService]
      },
      {
        path: "comisionadministracion/busqueda", loadChildren: () => import('./ComisionAdministracion/busqueda/busqueda.module').then(m => m.BusquedaModule), canActivate: [AppGuardService]
      },
      {
        path: "gestion-programa/indicadores-operativos", loadChildren: () => import('./gestion-programa/indicadores-operativos/indicadores-operativos.module').then(m => m.IndicadoresOperativosModule), canActivate: [AppGuardService]
      },
      {
        path: "gestion-programa/vista-resumen", loadChildren: () => import('./gestion-programa/vista-resumen/vista-resumen.module').then(m => m.VistaResumenModule), canActivate: [AppGuardService]
      },
      {
        path: "gestion-programa/reportes", loadChildren: () => import('./gestion-programa/reportes/reportes.module').then(m => m.ReportesModule), canActivate: [AppGuardService]
      },
      {
        path: "asociarpago/busqueda", loadChildren: () => import('./asociacionpagos/BusquedaAsociacionPagos.module').then(m => m.BusquedaAsociacionPagosModule), canActivate: [AppGuardService]
      },
      {
        path: "supervision-posterior/configurar-expedientes", loadChildren: () => import('./supervision-posterior/configurar-expedientes/configuracion-expedientes.module').then(m => m.ConfiguracionExpedientesModule), canActivate: [AppGuardService]
      },
      {
        path: "supervision-posterior/gestion-expedientes", loadChildren: () => import('./supervision-posterior/gestionar-expedientes/gestionar-expedientes.module').then(m => m.GestionarExpedientesModule), canActivate: [AppGuardService]
      },
      {
        path: "gestion-programa/resumen-cartera", loadChildren: () => import('./gestion-programa/resumen-cartera/resumen-cartera.module').then(m => m.ResumenCarteraModule), canActivate: [AppGuardService]
      },
      {
        path: "rectificacion/configurar", loadChildren: () => import('./rectificaciones/configurar-esf/busqueda/busqueda.module').then(m => m.BusquedaModule), canActivate: [AppGuardService]
      },
      {
        path: "rectificacion/registrosolicitud", loadChildren: () => import('./rectificaciones/registrar-rectificacion/registrar-rectificacion.module').then(m => m.RegistrarRectificacionModule), canActivate: [AppGuardService]
      },
      {
        path: "gestion-programa/preguntas-frecuentes", loadChildren: () => import('./gestion-programa/preguntas-frecuentes/preguntas-frecuentes.module').then(m => m.PreguntasFrecuentesModule), canActivate: [AppGuardService]
      },
      {
        path: "rectificacion/busquedasolicitud", loadChildren: () => import('./rectificaciones/busqueda-rectificacion/busqueda-rectificacion.module').then(m => m.BusquedaRectificacionModule), canActivate: [AppGuardService]
      },
      {
        path: "gestion-programa/noticias-importantes", loadChildren: () => import('./modal-listado-novedades-noticias/novedades-noticias.module').then(m => m.NovedadesNoticiasModule), canActivate: [AppGuardService]
      },
    ],
  },
  { path: 'pagina-401', component: Page401Component },
  { path: 'pagina-403', component: Page403Component },
  { path: 'pagina-408', component: Page408Component },
]

@NgModule({
  declarations: [],
  imports: [CommonModule, RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
